import script from "./InputSearchTertiary.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSearchTertiary.vue?vue&type=script&setup=true&lang=js"

import "./InputSearchTertiary.vue?vue&type=style&index=0&id=08c37cf6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08c37cf6"]])

export default __exports__